import type { Ref } from 'react';
import type { ReCAPTCHAProps } from 'react-google-recaptcha';
import GoogleReCAPTCHA from 'react-google-recaptcha';

import { useFeatureFlags } from 'hooks/useFeatureFlags';

export const ReCAPTCHA = ({
  ref,
  ...props
}: Omit<ReCAPTCHAProps, 'sitekey'> & { ref?: Ref<GoogleReCAPTCHA> }) => {
  const {
    flags: { disableRecaptchaValidationInStagingMockprod = false },
  } = useFeatureFlags();

  return (
    <GoogleReCAPTCHA
      ref={ref}
      size="invisible"
      {...props}
      sitekey={
        disableRecaptchaValidationInStagingMockprod
          ? '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI'
          : '6Lf8qBMjAAAAAOwxyhaWofwa1Pu5SIIPCRk4ICPq'
      }
    />
  );
};

export { GoogleReCAPTCHA };
